// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState-module__emptyState--NgT69","emptyStateHeading":"EmptyState-module__emptyStateHeading--rzLtD"};